import { useTranslation } from 'react-i18next';
import {
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { priceAnomalies } from '../../../mocks/data/itemRationalisationData';

/** Items with unusual/large price movements since the last recorded price. Read-only view -
 * approval already happens via the Governance Queue tab (PendingPriceApproval status). */
const PriceAnomaliesTab = () => {
  const { t } = useTranslation('productManagement');

  return (
    <Stack spacing={2}>
      <Typography variant="textSM"
        color="text.secondary">
        {t('rationalisation.priceAnomaliesIntro', 'Items with a significant price movement since the previous recorded price.')}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('itemNumber', 'Item Number')}</TableCell>
            <TableCell>{t('description', 'Description')}</TableCell>
            <TableCell align="right">{t('rationalisation.previousPrice', 'Previous price')}</TableCell>
            <TableCell align="right">{t('rationalisation.currentPrice', 'Current price')}</TableCell>
            <TableCell align="right">{t('rationalisation.change', 'Change')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {priceAnomalies.map((item) => (
            <TableRow key={item.itemNumber}>
              <TableCell>{item.itemNumber}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell align="right">{item.previousPrice.toFixed(2)}</TableCell>
              <TableCell align="right">{item.currentPrice.toFixed(2)}</TableCell>
              <TableCell align="right">
                <Chip
                  label={`+${item.changePercent.toFixed(1)}%`}
                  size="small"
                  color={item.changePercent > 25 ? 'error' : 'warning'}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default PriceAnomaliesTab;
